import { Image, Info } from 'components';

export default function SampleSizeInfo(props: InfoProps) {

    return <Info {...props}>
        <Image alt="Person with magnifying glass examining a group of people" path="sample-size.png" title="Sample Size" />
        <h5>Sample Size</h5>
        <p>
            This is the actual number of individuals within the <span className="fst-italic">Population</span> that you got data from in this experiment or variation.
            <br />
            <br />
            <span className="fw-bold">Example:</span> If you sent out a survey to 1,000 people and you wanted 500 people to respond, but only 300 people filled out the survey and responded, the <span className="fst-italic">Sample Size</span> is 300.
        </p>
    </Info>;

}